import { Head } from '@inertiajs/react'
import PageHeader from '@/components/common/PageHeader'

type FavoritePharmacy = {
  name: string
  address: string
}

type Props = {
  email: string
  favorite_pharmacy: FavoritePharmacy | null
}

export default function V2ConfirmEmail({ email, favorite_pharmacy }: Props) {
  return (
    <>
      <Head title="確認メール送信 - オンライン診療予約" />

      <div className="min-h-screen bg-white">
        <PageHeader subtitle="メール確認" />

        <main className="mx-auto max-w-3xl px-4 py-6">
          <div className="oc-card space-y-4 text-center">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-blue-50">
              <svg className="h-8 w-8 text-[#2196f3]" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
            </div>

            <h1 className="text-lg font-bold text-[#2a3039]">本人確認用のメールを送信しました</h1>

            <p className="text-sm text-[#515862]">
              <span className="font-medium text-[#2a3039]">{email}</span> 宛に確認メールを送信しました。
            </p>
            <p className="text-sm text-[#515862]">
              会員登録はまだ完了していません。メール内のリンクをクリックして、登録を完了してください。
            </p>

            {favorite_pharmacy && (
              <div className="rounded-lg border border-cyan-100 bg-cyan-50 p-4 text-left">
                <p className="text-xs font-medium text-cyan-700">お気に入り薬局を登録しました</p>
                <p className="mt-1 text-sm font-semibold text-[#2a3039]">{favorite_pharmacy.name}</p>
                <p className="text-xs text-[#7f8388]">{favorite_pharmacy.address}</p>
                <p className="mt-2 text-xs text-[#515862]">
                  次回以降のオンライン診療で、お薬の受け取り薬局として最初に選ばれます。
                </p>
                <p className="mt-1 text-xs text-[#515862]">
                  薬局が異なる場合は、会員情報ページからいつでも変更できます。
                </p>
              </div>
            )}

            <div className="rounded-lg border border-blue-100 bg-blue-50 p-4 text-left text-sm text-[#515862]">
              <p className="font-medium text-[#2a3039]">メールが届かない場合</p>
              <ul className="mt-2 list-inside list-disc space-y-1">
                <li>迷惑メールフォルダをご確認ください</li>
                <li>メールアドレスに間違いがないかご確認ください</li>
              </ul>
            </div>
          </div>
        </main>
      </div>
    </>
  )
}
